import { useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useIsInExclusivePreview from '~/hooks/vdp/selectors/useIsInExclusivePreview';
import useIsReservableVehicle from '~/hooks/vdp/selectors/useIsReservableVehicle';
import useIsWipVehicleReservedByUser from '~/hooks/vdp/selectors/useIsWipVehicleReservedByUser';
import useGetWipStatusBannerComponent from './WIPStatusBanner';

export default function useGetShowBanners() {
  const {
    vehicleAvailability: { isLoaded: isAvailabilityLoaded }
  } = useContext(UserVehicleContext);
  const isReservable = useIsReservableVehicle();
  const isWipReservedByUser = useIsWipVehicleReservedByUser();
  const isInExclusivePreview = useIsInExclusivePreview();
  const StatusBannerComponent = useGetWipStatusBannerComponent();

  const showWIPBanner =
    (isReservable || isInExclusivePreview || isWipReservedByUser) &&
    isAvailabilityLoaded &&
    StatusBannerComponent;

  return {
    showWIPBanner,
    isBannerShowing: showWIPBanner
  };
}
